import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Toast, Dialog } from 'react-weui'
import { browserHistory } from 'react-router'
import { CustomerServiceQrcode } from '../../components'
import { LectureList, ChannelList } from '../../components/liveroomLecturer'
import * as liveroomSetAct from '../../actions/liveroomSettingLecture'
import Config from '../../config'
import {isLZWKAPP} from '../../utils'
import {toLecture} from '../../utils/connectApp'


class LectureAndChannelList extends React.Component {
    componentDidMount () {
        this.props.setQrcodeInit({
            api: '/api/board/service/allocate',
            title: '长按二维码联系客服',
        })
    }
    pushPath (type, id) {
        if (type === 'lecture') {
            // location.assign(`/lecture/${id}`)
            if (isLZWKAPP()) {
                toLecture({ id: id })
            } else {
                window.location = `/lecture/${id}`
            }
        } else {
            // location.assign(`/channel/${id}`)
            if (isLZWKAPP()) {
                location.assign(`lizhiweike://channel?channel_id=${id}`)
            } else {
                window.location = `/channel/${id}`
            }
        }
    }
    onClickServiceOk () {
        this.props.setIsNoDel(false)
        this.props.setQrcodeShow()
    }
    componentWillUnmount () {
        this.props.setQrcodeHide()
    }
    render() {
        return (
            <div>
                { this.props.type === 'lecture' && <LectureList pushPath={this.pushPath} liveroomId={this.props.liveroomId} /> }
                { this.props.type === 'channel' && <ChannelList pushPath={this.pushPath} liveroomId={this.props.liveroomId} /> }

                <Toast icon="loading" show={this.props.isPending}>请求中</Toast>
                <Toast icon="success-no-circle" show={this.props.isSuccess}>操作成功</Toast>
                <Toast icon="info-circle" show={this.props.info.isInfo}>{this.props.info.infoText}</Toast>
                
                <Dialog type="ios" title='' show={this.props.isAlert} buttons={[{
                    label: '确定',
                    onClick: () => this.props.setIsAlert(false),
                }]}>
                    {this.props.alertMsg}
                </Dialog>

                <Dialog type="ios" title='' show={this.props.isNoDel} buttons={[{
                    label: '取消',
                    type: 'default',
                    onClick: () => this.props.setIsNoDel(false),
                }, {
                    label: '联系客服',
                    onClick: () => this.onClickServiceOk(),
                }]}>
                    {this.props.noDelReason || '不能删除此条目，您可以联系客服'}
                </Dialog>

                { this.props.customerservice.QrcodeShow && <CustomerServiceQrcode /> }
            </div>
        )
    }
}

export default connect(state => ({
    isPending: state.liveroomSettingLecture.isPending,
    isSuccess: state.liveroomSettingLecture.isSuccess,
    isAlert: state.liveroomSettingLecture.isAlert,
    alertMsg: state.liveroomSettingLecture.alertMsg,
    customerservice: state.customerservice,
    info: state.liveroomSettingLecture.info,
    isNoDel: state.liveroomSettingLecture.isNoDel,
    noDelReason: state.liveroomSettingLecture.noDelReason,
}), dispatch => bindActionCreators({ ...liveroomSetAct }, dispatch))(LectureAndChannelList)


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/LectureAndChannelList.js